/** @format */
export const getPotTypeData = (state) => state.pots.potTypeData;
export const getSelectedRiskMandate = (state) => state.pots.potData.riskMandate;
